import {Accordion, AccordionDetails, AccordionTitle, CopyText, Icon, SessionHistoryNotesList} from 'components';
import {SessionHistory} from 'interfaces';

type Props = {
    session: SessionHistory;
    localUserEid: number;
}

export const SessionNotesAccordion: React.FC<Props> = ({session, localUserEid}) => (
    <Accordion shadow={false} padding={false} className='tw-my-2'>
        <AccordionTitle iconPlacement='right' className='tw-bg-default tw-p-2 tw-rounded-lg'>
            <div className='tw-flex tw-items-center'>
                <Icon name='id' className='tw-mr-1' />
                <CopyText text={session.sessionId} className='tw-ts-base' labelPlacement='left' iconSize='sm' />
            </div>
        </AccordionTitle>
        <AccordionDetails>
            <SessionHistoryNotesList session={session} localUserEid={localUserEid} />
        </AccordionDetails>
    </Accordion>
);